/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://43ipu4wzpng4pkoomsmdkmbpza.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-jav2wjwekrf2ncplctazgnfc2u",
    "aws_cognito_identity_pool_id": "us-east-1:2c136320-e153-4722-a55d-b9b0aabc3ab5",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_mMGX2CQgM",
    "aws_user_pools_web_client_id": "7g9qtqhoo5mi2rbrai8vv4hds3",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "aws-athena-query-results-bubble-dashboard190218-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
